__turbopack_context__.v({
  "icon": "dealLink-module-scss-module__5X6vhG__icon",
});
